import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { BackgroundWrapper } from "../../section.component"
import Box from "../../../../../images/box.svg"
import SwiperCore, { Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.min.css"
import useTranslationHook from "../../../../../hooks/use-translation.hook"
import {
  ControlsNextIcon,
  ControlsPrevIcon,
} from "../quick-start/quick-start-mobile-controls.component"
import { SliderButtonStyle } from "../quick-start-element/quick-start-element.styled"

SwiperCore.use([Navigation])

const Container = styled.div`
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    padding: 3rem 2rem;
  }
`

const Title = styled.h2`
  color: var(--Text-primary, #000);

  /* Heading/H2 */
  font-family: Facto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 27.6px */
  max-width: 600px;
  margin-bottom: 3rem;
  box-sizing: border-box;
  width: 100%;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    text-align: left;
    font-size: 23px;
  }
`

const ComparisonTable = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background-color: transparent;
  box-shadow: none;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoint.tablet - 1}px) {
    display: none;
  }
`

const MobileComparisonWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: none;
  }

  .swiper-container {
    width: 100% !important;
    overflow: hidden !important;
  }
`

const SwiperWrapper = styled(Swiper)`
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;

  .swiper-wrapper {
    width: 100% !important;
    max-width: 100% !important;
  }

  .swiper-slide {
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
  }

  /* Hide default Swiper navigation buttons */
  .swiper-button-next,
  .swiper-button-prev {
    display: none !important;
  }
`

const MobileSlideContent = styled.div`
  padding: 0;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
  overflow: hidden;
`

const MobileHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
`

const MobileVersionTitle = styled.div`
  text-align: center;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-top: 0.5rem;
  width: 100%;
  box-sizing: border-box;
`

const MobileTableRow = styled.div`
  margin-bottom: 1rem;

  border-radius: 12px;
  padding: 1rem;
  width: 100%;
  box-sizing: border-box;

  &:nth-child(even) {
    background-color: #fff;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

const MobileRowLabel = styled.div`
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 2rem;
  width: 100%;
  box-sizing: border-box;
`

const MobileRowValue = styled.div`
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  word-break: break-word;
  width: 100%;
  box-sizing: border-box;
`

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-template-columns: 2fr 1fr 1fr;
  }
`

const HeaderCell = styled.div`
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  box-sizing: border-box;

  &:first-child {
    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
      display: block;
    }
  }
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  box-sizing: border-box;
`

// const BoxIcon = styled.div`
//   width: 24px;
//   height: 24px;
//   background-color: #000;
//   box-sizing: border-box;
// `

const VersionTitle = styled.div`
  text-align: center;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 30px */
  box-sizing: border-box;
`

const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  box-sizing: border-box;

  &:nth-child(even) {
    background-color: #fff;
    border-radius: 12px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-template-columns: 2fr 1fr 1fr;
  }

  &:last-child {
    border-bottom: none;
  }
`

const RowLabel = styled.div`
  display: none;
  padding: 1rem;
  font-weight: 500;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: flex;
    align-items: center;
  }
`

const RowValue = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    padding: 1.25rem;
  }
`

const MobileLabel = styled.div`
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 21px */
  margin-bottom: 2rem;
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: none;
  }
`

// Custom navigation components
const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 3rem;
  width: 100%;
  box-sizing: border-box;
  gap: 1rem;
`

// const NavigationButton = styled.button<{ disabled: boolean }>`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: none;
//   border: none;
//   font-family: Montserrat;
//   font-size: 14px;
//   font-weight: 600;
//   text-transform: uppercase;
//   letter-spacing: 0.1em;
//   color: ${({ disabled }) => (disabled ? "#CCCCCC" : "#000000")};
//   cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
//   padding: 0.75rem 1rem;
//   transition: opacity 0.2s ease;

//   svg {
//     fill: ${({ disabled }) => (disabled ? "#CCCCCC" : "#000000")};
//   }

//   &:hover {
//     opacity: ${({ disabled }) => (disabled ? 1 : 0.7)};
//   }
// `

const KompaktFitComparison = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const { translate } = useTranslationHook()
  const swiperRef = useRef<SwiperCore | null>(null)

  // Force resize event on component mount to ensure Swiper properly sizes itself
  useEffect(() => {
    const resizeEvent = window.document.createEvent("UIEvents")
    resizeEvent.initUIEvent("resize", true, false, window, 0)
    window.dispatchEvent(resizeEvent)
  }, [])

  // Custom navigation handlers
  const handlePrev = () => {
    if (swiperRef.current && activeIndex > 0) {
      setTimeout(() => {
        const element = document.getElementById(`mobile-slide-normal`)
        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY
          window.scrollTo({
            top: elementPosition - 65,
            behavior: "smooth",
          })
        }
      }, 100)
      swiperRef.current.slidePrev()
    }
  }

  const handleNext = () => {
    if (swiperRef.current && activeIndex < 1) {
      setTimeout(() => {
        const element = document.getElementById(`mobile-slide-normal`)
        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY
          window.scrollTo({
            top: elementPosition - 65,
            behavior: "smooth",
          })
        }
      }, 100)
      swiperRef.current.slideNext()
    }
  }

  // Data for the comparison table
  const comparisonData = [
    {
      label: translate("target-regions"),
      globalValue: translate("target-regions-global"),
      northAmericaValue: translate("target-regions-na"),
    },
    {
      label: translate("2g-bands"),
      globalValue: translate("2g-bands-global"),
      northAmericaValue: translate("2g-bands-na"),
    },
    {
      label: translate("3g-bands"),
      globalValue: translate("3g-bands-global"),
      northAmericaValue: translate("3g-bands-na"),
    },
    {
      label: translate("4g-lte-fdd"),
      globalValue: translate("4g-lte-fdd-global"),
      northAmericaValue: translate("4g-lte-fdd-na"),
    },
    {
      label: translate("4g-lte-tdd"),
      globalValue: translate("4g-lte-tdd-global"),
      northAmericaValue: translate("4g-lte-tdd-na"),
    },
    {
      label: translate("voice-over-lte"),
      globalValue: translate("voice-over-lte-global"),
      northAmericaValue: translate("voice-over-lte-na"),
    },
    {
      label: translate("wifi-calling"),
      globalValue: translate("wifi-calling-global"),
      northAmericaValue: translate("wifi-calling-na"),
    },
  ]

  return (
    <BackgroundWrapper background="#F4F5F7">
      <Container>
        <Title>{translate("kompakt-fit-title")}</Title>

        {/* Mobile Swiper version */}
        <MobileComparisonWrapper id="mobile-slide-normal">
          <SwiperWrapper
            spaceBetween={0}
            slidesPerView={1}
            onSwiper={(swiper) => {
              swiperRef.current = swiper
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          >
            {/* Global Optimized Slide */}
            <SwiperSlide>
              <MobileSlideContent>
                <MobileHeader>
                  <IconContainer>
                    <img src={Box} alt="Box icon" width={40} height={40} />
                  </IconContainer>
                  <MobileVersionTitle>
                    {translate("global-optimized")}
                  </MobileVersionTitle>
                </MobileHeader>

                {comparisonData.map((item, index) => (
                  <MobileTableRow key={`global-${index}`}>
                    <MobileRowLabel>{item.label}</MobileRowLabel>
                    <MobileRowValue>{item.globalValue}</MobileRowValue>
                  </MobileTableRow>
                ))}
              </MobileSlideContent>
            </SwiperSlide>

            {/* North America Optimized Slide */}
            <SwiperSlide>
              <MobileSlideContent>
                <MobileHeader>
                  <IconContainer>
                    <img src={Box} alt="Box" width={40} height={40} />
                  </IconContainer>
                  <MobileVersionTitle>
                    {translate("north-america-optimized")}
                  </MobileVersionTitle>
                </MobileHeader>

                {comparisonData.map((item, index) => (
                  <MobileTableRow key={`na-${index}`}>
                    <MobileRowLabel>{item.label}</MobileRowLabel>
                    <MobileRowValue>{item.northAmericaValue}</MobileRowValue>
                  </MobileTableRow>
                ))}
              </MobileSlideContent>
            </SwiperSlide>
          </SwiperWrapper>

          {/* Custom navigation controls */}
          <ControlsContainer>
            <SliderButtonStyle
              onClick={handlePrev}
              disabled={activeIndex === 0}
              disabledPrev={activeIndex === 0}
              aria-label={translate("PREV")}
            >
              <ControlsPrevIcon /> {translate("PREV")}
            </SliderButtonStyle>
            <SliderButtonStyle
              onClick={handleNext}
              disabled={activeIndex === 1}
              disabledNext={activeIndex === 1}
              aria-label={translate("NEXT")}
            >
              {translate("NEXT")} <ControlsNextIcon />
            </SliderButtonStyle>
          </ControlsContainer>
        </MobileComparisonWrapper>

        {/* Desktop table version */}
        <ComparisonTable>
          <TableHeader>
            <HeaderCell></HeaderCell>
            <HeaderCell>
              <IconContainer>
                <img src={Box} alt="Box icon" width={40} height={40} />
              </IconContainer>
              <VersionTitle>{translate("global-optimized")}</VersionTitle>
            </HeaderCell>
            <HeaderCell>
              <IconContainer>
                <img src={Box} alt="Box" width={40} height={40} />
              </IconContainer>
              <VersionTitle>
                {translate("north-america-optimized")}
              </VersionTitle>
            </HeaderCell>
          </TableHeader>

          {comparisonData.map((item, index) => (
            <TableRow key={`row-${index}`}>
              <RowLabel>{item.label}</RowLabel>
              <RowValue>
                <MobileLabel>{item.label}</MobileLabel>
                {item.globalValue}
              </RowValue>
              <RowValue>
                <MobileLabel>{item.label}</MobileLabel>
                {item.northAmericaValue}
              </RowValue>
            </TableRow>
          ))}
        </ComparisonTable>
      </Container>
    </BackgroundWrapper>
  )
}

export default KompaktFitComparison
